module.exports = __webpack_public_path__ + "img/vip_room_min_5.849330db.png";